import { render, staticRenderFns } from "./TunDataItem.vue?vue&type=template&id=54a6dcf8&scoped=true&"
import script from "./TunDataItem.vue?vue&type=script&lang=js&"
export * from "./TunDataItem.vue?vue&type=script&lang=js&"
import style0 from "./TunDataItem.vue?vue&type=style&index=0&id=54a6dcf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6dcf8",
  null
  
)

export default component.exports